module.exports = __webpack_public_path__ + "static/media/arrow-left-cyan.6b13c9c7.svg";